'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewsCarousel = function () {
  function ReviewsCarousel(el) {
    (0, _classCallCheck3.default)(this, ReviewsCarousel);

    var _this = this;
    var context = { context: el };

    this.els = {
      el: el,
      slides: (0, _functional.getElement)('.js-ItemCarousel_Items', context),
      dots: (0, _functional.getElement)('.js-ItemCarousel_Dots', context),
      controls: (0, _functional.getElement)('.js-ItemCarousel_Controls', context),
      prev: (0, _functional.getElement)('.js-ItemCarousel_Control-prev', context),
      next: (0, _functional.getElement)('.js-ItemCarousel_Control-next', context)
    };

    this.amountOfDotsWanted = null;
    this.dotEls = null;

    this.initialised = false;

    this.perSlide = parseInt(this.els.el.dataset.perSlide, 10);
    this.autoplay = typeof this.els.el.dataset.autoplay !== 'undefined' ? this.els.el.dataset.autoplay : 'false';
    this.device = typeof this.els.el.dataset.device !== 'undefined' ? this.els.el.dataset.device : 'all';

    this.carousel = new _siema2.default({
      selector: this.els.slides,
      duration: 500,
      perPage: this.perSlide,
      loop: true,
      onInit: function onInit() {
        var carousel = this;

        _this.initialised = true;

        _this.initialiseDots(carousel);
        _this.initialiseControls(carousel);

        if (_this.autoplay === 'true') {
          setInterval(function () {
            carousel.next(1);
          }, 4000);
        }

        carousel.innerElements.forEach(function (carouselItem, index) {
          carouselItem.setAttribute('aria-current', String(index === carousel.currentSlide));
        });

        window.addEventListener('load', function () {
          return _this.handleResize(_this);
        });

        window.addEventListener('resize', function () {
          return _this.handleResize(_this);
        });
      },
      onChange: function onChange() {
        var carousel = this;

        carousel.innerElements.forEach(function (carouselItem, index) {
          carouselItem.setAttribute('aria-current', String(index === carousel.currentSlide));
        });

        if (_this.els.dots != null) {
          _this.dotEls.forEach(function (dotEl, index) {
            dotEl.setAttribute('aria-current', String(index === carousel.currentSlide));
          });
        }
      }
    });
  }

  (0, _createClass3.default)(ReviewsCarousel, [{
    key: 'initialiseDots',
    value: function initialiseDots(carousel) {
      var _this2 = this;

      if (this.els.dots != null) {
        this.amountOfDotsWanted = carousel.innerElements.length - (carousel.perPage - 1);
        this.dotEls = (0, _functional.range)(this.amountOfDotsWanted).map(function (_, index) {
          return (0, _functional.createElement)('div', {
            class: 'js-ItemCarousel_Dot',
            'aria-current': String(index === carousel.currentSlide)
          });
        }).map(function (el) {
          return _this2.els.dots.appendChild(el);
        });

        this.dotEls.forEach(function (el, index) {
          return el.addEventListener('click', function () {
            return carousel.goTo(index);
          });
        });
      }
    }
  }, {
    key: 'initialiseControls',
    value: function initialiseControls(carousel) {
      if (this.els.prev && this.els.next) {
        this.els.prev.addEventListener('click', function () {
          return carousel.prev();
        });
        this.els.next.addEventListener('click', function () {
          return carousel.next();
        });
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize(context) {
      if (context.device === 'mobile' && window.innerWidth > _utils.mediaBreakpoints.sm && context.initialised) {
        context.initialised = false;
        context.carousel.destroy(true);
        context.els.dots.innerHTML = '';
      }

      if (context.device === 'mobile' && window.innerWidth < _utils.mediaBreakpoints.sm && !context.initialised) {
        context.carousel.init();
      }

      if (context.device === 'desktop' && window.innerWidth < _utils.mediaBreakpoints.sm && context.initialised) {
        context.initialised = false;
        context.carousel.destroy(true);
        context.els.dots.innerHTML = '';
      }

      if (context.device === 'desktop' && window.innerWidth > _utils.mediaBreakpoints.sm && !context.initialised) {
        context.carousel.init();
      }

      if (context.device === 'none' && context.initialised) {
        context.initialised = false;
        context.carousel.destroy(true);
        context.els.dots.innerHTML = '';
      }
    }
  }]);
  return ReviewsCarousel;
}();

exports.default = ReviewsCarousel;